import { render, staticRenderFns } from "./FrameCheckHome.vue?vue&type=template&id=03894f14&scoped=true&"
import script from "./FrameCheckHome.vue?vue&type=script&lang=js&"
export * from "./FrameCheckHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03894f14",
  null
  
)

export default component.exports